import api from '../api';

type ParamsReponse = {
    Data: HTMLElement;
}

export const GetServiceTerms = async ({ token, type }: { token: string, type: number }) => {
    try {
        const { data } = await api.get<ParamsReponse>(`v1/Pagamento/GetServiceTerm/${type}?termoServicoEnum=${type}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
